import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import FormInputText from '../../_shared/forms/FormInputText';
import SubmitButton from '../../_shared/SubmitButton';
import UploadPhotos from './partials/UploadPhotos';
import WasteTippingService from '../../../services/WasteTippingService';

class EditWasteTipping extends Component {
    constructor(props) {
        super(props);

        this.wasteTippingService = new WasteTippingService();
        const el = document.getElementById('show-tipping');

        this.state = {
            wasteTipping: JSON.parse(el.dataset.wasteTipping),
            jobs: JSON.parse(el.dataset.jobs),
            receipts: JSON.parse(el.dataset.receipts),
            members: JSON.parse(el.dataset.members),
            tipOff: JSON.parse(el.dataset.tipOff),
            updateRoute: el.dataset.updateRoute,
            uploadedImages: JSON.parse(el.dataset.receipts).map(r => r.url) || [],
            wood: JSON.parse(el.dataset.wasteTipping).wood || 0,
            green_waste: JSON.parse(el.dataset.wasteTipping).green_waste || 0,
            general: JSON.parse(el.dataset.wasteTipping).general || 0,
            inert: JSON.parse(el.dataset.wasteTipping).inert || 0,
            loading: false,
        };
    }

    handleInputChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleFileChange = (acceptedFiles) => {
        acceptedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onload = (ev) => {
                this.setState((prev) => ({
                    uploadedImages: [...prev.uploadedImages, ev.target.result],
                }));
            };
            reader.readAsDataURL(file);
        });
    };

    removeImage = (index) => {
        this.setState((prev) => {
            const uploadedImages = [...prev.uploadedImages];
            uploadedImages.splice(index, 1);
            return { uploadedImages };
        });
    };
    saveWasteTipping = (e) => {
        e.preventDefault(); 

        this.setState({ loading: true });

        const { uploadedImages, wood, green_waste, general, inert, wasteTipping } = this.state;

        const data = {
            wood,
            green_waste,
            general,
            inert,
            tipoff_images: uploadedImages
        };

        this.wasteTippingService.update(this.state.wasteTipping.provider_id, wasteTipping.id, data)
            .then((res) => {
                console.log('Server response:', res.data);
                alert('Waste tipping saved!');
                this.setState({ loading: false });
            })
            .catch((err) => {
                console.error('Error saving waste tipping:', err.response ? err.response.data : err);
                alert('Error saving waste tipping.');
                this.setState({ loading: false });
            });
    };

    render() {
        const { jobs, members, uploadedImages, wood, green_waste, general, inert, wasteTipping, loading } = this.state;

        return (
            <Fragment>
                <form onSubmit={this.saveWasteTipping} className="transform-text">
                    <div className="row pb-3">
                        <div className="col-12">
                            <h6 className="py-2 pl-2 cw-bg-grey text-white">Waste Details</h6>
                        </div>
                    </div>
                    <div className="row pb-3">
                        <div className="col-6">
                            <strong>Tipping Site</strong>
                            <p>{wasteTipping.tip_off.name}</p>
                        </div>
                        <div className="col-6">
                            <strong>Tipping Date</strong>
                            <p>{wasteTipping.tipping_date}</p>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="form-group col-md-3">
                            <FormInputText
                                type="number"
                                label="Wood waste"
                                name="wood"
                                value={wood}
                                className="form-control"
                                onChange={this.handleInputChange}
                            />
                        </div>
                        <div className="col-md-3">
                            <FormInputText
                                type="number"
                                label="Green Waste"
                                name="green_waste"
                                value={green_waste}
                                className="form-control"
                                onChange={this.handleInputChange}
                            />
                        </div>
                        <div className="col-md-3">
                            <label></label>
                            <FormInputText
                                type="number"
                                label="General waste"
                                name="general"
                                value={general}
                                className="form-control"
                                onChange={this.handleInputChange}
                            />
                        </div>
                        <div className="col-md-3">
                            <FormInputText
                                type="number"
                                label="Inert waste"
                                name="inert"
                                value={inert}
                                className="form-control"
                                onChange={this.handleInputChange}
                            />
                        </div>
                    </div>
                    <div className="row pb-3">
                        <div className="col-12">
                            <h6 className="py-2 pl-2 cw-bg-grey text-white">Jobs Associated</h6>
                        </div>
                    </div>
                    <div className="row mb-3">
                        {jobs.map((job) => (
                            <div key={job.id} className="col-md-6 mb-2">
                                <p className="mb-0">
                                    <strong>Job ID:</strong> {job.id}
                                </p>
                                <p className="mb-0">
                                    <strong>Type:</strong> {job.job_type.name}
                                </p>
                                <p className="mb-0">
                                    <strong>Address:</strong> {job.address_line_1}
                                </p>
                                <p className="mb-0">
                                    <strong>Completion:</strong> {job.completion_date}
                                </p>
                            </div>
                        ))}
                    </div>
                    <div className="row pb-3">
                        <div className="col-12">
                            <h6 className="py-2 pl-2 cw-bg-grey text-white">Operatives & Signature</h6>
                        </div>
                    </div>
                    <div className="row mb-3">
                        {members.map((member) => (
                            <div key={member.id} className="col-md-4 mb-2">
                                <p>
                                    <strong>Operative:</strong> {member.name}
                                </p>
                                {member.signature_url && (
                                    <img
                                        src={member.signature_url}
                                        alt="Signature"
                                        className="img-fluid"
                                        style={{ maxHeight: '100px' }}
                                    />
                                )}
                            </div>
                        ))}
                    </div>
                    <div className="row pb-3">
                        <div className="col-12">
                            <h6 className="py-2 pl-2 cw-bg-grey text-white">Receipts</h6>
                        </div>
                    </div>
                    <UploadPhotos
                        uploadedImages={this.state.uploadedImages}
                        onFilesAdded={this.handleFileChange}
                        onRemoveImage={this.removeImage}
                    />
                    <SubmitButton
                        buttonText="Save Changes"
                        loading={this.state.loading}
                        style={{ width: 200, marginTop: 20 }}
                    />
                </form>
            </Fragment>
        );
    }
}

if (document.getElementById('show-tipping')) {
    ReactDOM.render(<EditWasteTipping />, document.getElementById('show-tipping'));
}

export default EditWasteTipping;
